import React from 'react';
import signatureTypes from '../../../../../constants/SignatureTypes';

export const INNER_SIGN = signatureTypes.DSS;
export const ITEX_CERTIFICATE = signatureTypes.ITEX;
export const QUAL_SING = signatureTypes.QES;
export const NO_CERTIFICATE = 'NONE';

const listClass = 'list list__blue';
const textClass = 'text-small';
export const signOptions = [
  {
    value: INNER_SIGN,
    label: 'Ключ электронной подписи хранится в защищенной системе ФНС России (рекомендовано)',
    description: (
      <div>
        <p>ЭП можно использовать при работе на любых мобильных устройствах.</p>
        <p>
          <span className="bold">Внимание! </span>
          Для работы с новой версией Личного кабинета требуется новая электронная подпись (ЭП).
          Данная ЭП&nbsp; действительна только в рамках взаимодействия с налоговыми органами через
          новую версию сервиса&nbsp; «Личный кабинет налогоплательщика для физических лиц».
        </p>
      </div>
    ),
    tooltipContent: (
      <ul className={listClass}>
        <li>
          <p className={textClass}>Для работы необходим браузер.</p>
        </li>
        <li>
          <p className={textClass}>
            Невозможен доступ к ключу электронной подписи посторонних лиц, включая работников ФНС
            России,&nbsp; невозможно копирование ключа электронной подписи
          </p>
        </li>
      </ul>
    ),
    tooltipTitle: null,
    hasWrapper: false,
    tooltipCloseByClick: true,
  },
  {
    value: ITEX_CERTIFICATE,
    label: 'Электронная подпись хранится на Вашей рабочей станции',
    description: (
      <div>
        <p>
          Устанавливается на ваш компьютер. Не поддерживается работа на мобильных устройствах.
          Необходимо обеспечить&nbsp; защиту ключа электронной подписи на Вашем компьютере от
          посторонних лиц.
        </p>
        <p>
          <span className="bold">Внимание!</span> Пользователю предоставляется возможность скачать
          один сертификат&nbsp; сроком действия один год. Рекомендуем Вам осуществить установку
          сертификата на компьютер, с которого Вы&nbsp; чаще всего осуществляете вход в сервис.
          После установки сертификата Вы сможете перенести его на другой&nbsp; компьютер.
        </p>
      </div>
    ),
    tooltipContent: (
      <div className="help_content">
        <p className={textClass}>
          Для использования ЭП, хранящейся на Вашем ПК, потребуется выполнение ряда технических
          условий:
        </p>
        <ol className="list list-number">
          <li>
            ОС Microsoft Windows версий XP, Vista, 7, 8, 10 или MacOS X MountainLion 10.8.5.x и
            более поздние версии.
          </li>
          <li>
            Веб-браузер Internet Explorer 10 или более поздней версии, Google Chrome, Mozilla
            Firefox, Opera последних версий. Для операционной системы MacOS: веб-браузер Safari,
            GoogleChrome последних версий.
          </li>
          <li>
            Средства ЭП (Microsoft Windows -&nbsp;
            <a href="https://lkfl2.nalog.ru/lkfl/download/setup.exe">скачать</a>, для MacOS -&nbsp;
            <a href="https://lkfl2.nalog.ru/lkfl/download/setup.dmg">скачать</a>). Для установки
            средств ЭП необходимы&nbsp; права администратора на ПК. После установки потребуется
            перезагрузка ПК и повторная авторизация в Личном кабинете.
          </li>
        </ol>
      </div>
    ),
    tooltipTitle: null,
    hasWrapper: false,
    tooltipCloseByClick: true,
  },
  {
    value: QUAL_SING,
    label: 'Регистрация имеющейся квалифицированной подписи',
    description:
      'Если у Вас уже есть квалифицированная электронная подпись, выданная Удостоверяющим центром, ' +
      'аккредитованным Минцифры России, ее необходимо зарегистрировать в системе электронного документооборота ' +
      'ФНС России.',
    tooltipContent: (
      <div>
        <p className={textClass}>
          Для регистрации сертификата квалифицированной ЭП необходимо выполнение ряда технических
          условий:
        </p>
        <ul className={listClass}>
          <li>
            <p className={textClass}>
              Крипто ПРО CSP 3.6 или выше с действующей лицензией&nbsp;
              <a
                href="https://www.cryptopro.ru/user/login?destination=system%2Ffiles%2Fprivate%2Fcsp%2F40%2F9842%2FCSPSetup.exe"
                target="_blank"
              >
                (скачать);
              </a>
            </p>
          </li>
          <li>
            <p className={textClass}>
              установлен плагин для работы с ЭЦП (
              <a href="https://www.cryptopro.ru/products/cades/plugin/get_2_0" target="_blank">
                скачать
              </a>
              &nbsp;КриптоПро ЭЦП Browser plug-in)
            </p>
          </li>
        </ul>
        <p>
          Установить корневой сертификат&nbsp;
          <a href="http://uc.nalog.ru/crt/CA_FNS_Russia_2015.crt" target="_blank">
            УЦ ФНС России
          </a>
        </p>
      </div>
    ),
    tooltipTitle: null,
    hasWrapper: false,
    tooltipCloseByClick: true,
  },
];
/*todo: add email in certificate fields*/
export const registered = 'registered';
export const inProcess = 'inProcess';
export const error = 'error';
export const remove = 'remove';
export const removeForRegister = 'removeForRegister';
export const revoked = 'revoked';
export const expired = 'expired';
export const statusMessages = {
  [INNER_SIGN]: {
    [registered]: <h4 className="page_margin30">Сертификат электронной подписи успешно выпущен</h4>,
    [inProcess]:
      'Запрос на получение сертификата отправлен. Процесс может занять от 30 минут до суток. ' +
      'Вы можете продолжить работу в Личном кабинете или в случае необходимости выйти из Личного кабинета - ' +
      'информация о готовности сертификата появится при следующем входе на эту страницу.',
    [error]: 'Ошибка генерации сертификата',
  },
  [QUAL_SING]: {
    [registered]: (
      <h4 className="page_margin30">
        Сертификат Вашей квалифицированной электронной подписи успешно зарегистрирован
      </h4>
    ),
    [inProcess]:
      'Запрос на регистрацию сертификата отправлен в систему электронного документооборота.' +
      ' Процесс может занять от 30 минут до суток. Вы можете продолжить работу в "Личном кабинете" или в случае необходимости выйти из ' +
      '"Личного кабинета" - информация о результате регистрации появится при следующем входе на эту страницу',
    [error]: 'Ошибка регистрации ЭП',
  },
  [ITEX_CERTIFICATE]: {
    [registered]: (
      <div>
        <h4 className="page_margin30">
          Сертификат электронной подписи успешно выпущен и установлен
        </h4>
        <div className="link link_attention page_margin20">
          Теперь Вы можете подписывать и направлять в налоговый орган декларации, заявления и иные
          документы.
        </div>
        <ul className={listClass}>
          <li>
            Для того, чтобы использовать ЭП на другом компьютере, воспользуйтесь&nbsp;
            <a href="https://lkfl.nalog.ru/lk/vipnet-container-transfer.pdf">данной инструкцией</a>
            &nbsp; (предварительно необходимо скачать сертификат).
          </li>
          <li>
            В случае утраты (компрометации) сертификата необходимо отозвать текущий сертификат,
            после чего&nbsp; сформировать запрос на выпуск нового.
          </li>
        </ul>
      </div>
    ),
    [inProcess]:
      'Запрос на регистрацию сертификата отправлен в систему электронного документооборота.' +
      ' Процесс может занять от 30 минут до суток. Вы можете продолжить работу в "Личном кабинете" или в случае необходимости выйти из ' +
      '"Личного кабинета" - информация о результате регистрации появится при следующем входе на эту страницу',
    [error]: 'Ошибка генерации сертификата',
  },
};
export const deleteCertificateStatusMessages = {
  [INNER_SIGN]: {
    [error]:
      'В данный момент сертификат не может быть отозван. Пожалуйста, повторите попытку позже',
    [remove]:
      'Вы уверены, что хотите отозвать текущий сертификат? После указанного действия сертификат утратит силу, ' +
      'Вам будет предложено формирование нового сертификата',
    [removeForRegister]:
      'У Вас уже зарегистрирован другой сертификат электронной подписи. Отозвать старый сертификат?',
    [revoked]: 'Сертификат успешно отозван. Вы можете зарегистрировать другой сертификат',
    url: 'revoke_dss',
  },
  [QUAL_SING]: {
    [error]: 'В данный момент сертификат не может быть удален. Пожалуйста, повторите попытку позже',
    [remove]:
      'Вы уверены, что хотите удалить текущий сертификат? После указанного действия сертификат утратит силу, ' +
      'Вам будет предложено формирование нового сертификата',
    [removeForRegister]:
      'У Вас уже зарегистрирован другой сертификат электронной подписи. Удалить старый сертификат?',
    [revoked]: 'Сертификат успешно удален. Вы можете зарегистрировать другой сертификат',
    url: 'delete_qes',
  },
  [ITEX_CERTIFICATE]: {
    [error]:
      'В данный момент сертификат не может быть отозван. Пожалуйста, повторите попытку позже',
    [remove]:
      'Вы уверены, что хотите отозвать текущий сертификат? После указанного действия сертификат утратит силу, ' +
      'Вам будет предложено формирование нового сертификата',
    [removeForRegister]:
      'У Вас уже зарегистрирован другой сертификат электронной подписи. Отозвать старый сертификат?',
    [revoked]: 'Сертификат успешно отозван. Вы можете зарегистрировать другой сертификат',
    url: 'revoke_vipnet',
  },
};
